import { type SeenFeedIds, toBodyFilter } from './feedSeenIds';

export const FEED_SIZE = 3;

interface FeedQueryScope {
  isLogin: boolean;
  codeRegion?: string;
  codeSubRegion?: string;
  seenIds: SeenFeedIds;
}

export const buildFeedQueryKey = ({
  isLogin,
  codeRegion,
  codeSubRegion,
  seenIds,
}: FeedQueryScope) =>
  [
    'feed',
    isLogin ? 'auth' : 'guest',
    codeRegion ?? '',
    codeSubRegion ?? '',
    seenIds,
  ] as const;

export const buildFeedBody = ({
  page,
  codeRegion,
  codeSubRegion,
  seenIds,
}: Omit<FeedQueryScope, 'isLogin'> & { page: number }) => ({
  page,
  size: FEED_SIZE,
  ...(codeRegion && { regionCode: codeRegion }),
  ...(codeSubRegion && { subRegionCode: codeSubRegion }),
  ...toBodyFilter(seenIds),
});
